export default {
  quickPriceEdit: {
    popover: {
      title: 'Save time editing prices',
      content: 'Now it\'s easier to keep your listing prices competitive.',
    },
    modal: {
      title: 'Edit Price',
      moneyInput: {
        label: 'Your Price',
        originalPriceHelpText: 'Was {{originalPrice}}',
        priceDropPrompt: '{{percentOff}}% price drop',
        originalPriceWithPriceDropHelpText: 'Was {{originalPrice}}. {{priceDropHTML}}',
        dropMorePrompt: 'Buyers see indications of price drops greater than 4%',
      },
      percentOffFilterChips: {
        label: 'Drop the price by',
        percentOff: '{{percentOff}}% Off',
      },
      genericError: 'Unexpected error occurred. Please try again.',
      priceRecommendation: {
        estimatedPriceRange: 'Estimated price range:',
      },
    },
    successToast: {
      text: 'Changes saved.',
    },
  },
  sellerListingCard: {
    sku: 'SKU: {{sku}}',
    inStock: '{{inventory}} in stock',
    condition: '{{condition}} Condition',
    views: {
      zero: 'No Views',
      one: '{{count}} View',
      other: '{{count}} Views',
    },
    watchers: {
      zero: 'No Watchers',
      one: '{{count}} Watcher',
      other: '{{count}} Watchers',
    },
    offers: {
      zero: 'No Offers',
      one: '{{count}} Offer',
      other: '{{count}} Offers',
    },
    orders: {
      one: '{{count}} Order',
      other: '{{count}} Orders',
    },
    daysAgo: {
      one: '{{count}} day old',
      other: '{{count}} days old',
    },
    monthsAgo: {
      one: '{{count}} month old',
      other: '{{count}} months old',
    },
    yearsAgo: {
      one: '{{count}} year old',
      other: '{{count}} years old',
    },
    states: {
      draft: 'Draft',
      ended: 'Ended',
      expired: 'Expired',
      live: 'Live',
      ordered: 'Sold',
      sold: 'Sold',
      soldOut: 'Sold Out',
      suspended: 'Suspended',
      upcoming: 'Upcoming',
    },
  },
};
